module.exports = __webpack_public_path__ + "img/sy.82986116.png";